import { contentApi, zimbaApi } from '@/infrastructure/Configuration'

export default class DestinationService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async getBrands () {
    const url = `${contentApi}/destinations/brands`
    const response = await this.httpClient.get(url)

    return response.data.brands
  }

  async getDestinationHotelTypes () {
    const url = `${contentApi}/destinations/hotel-types`
    const response = await this.httpClient.get(url)

    return response.data.types
  }

  async getOfferHotelCategories () {
    const url = `${contentApi}/offers/categories`
    const response = await this.httpClient.get(url)
    const categories = response.data.categories
    return Object.keys(categories).map((key) => ({ code: key, name: categories[key].name }))
  }

  async getHotelsByBrand (brandCode) {
    const url = `${zimbaApi}/destinations/hotels`
    const response = await this.httpClient.get(url, { params: { brand: brandCode } })

    return response.data.hotels
  }

  async getHotels (hotelCodes) {
    const params = {
      hotelCodes: hotelCodes.join(',')
    }
    const url = `${contentApi}/hotels`
    const response = await this.httpClient.get(url, { params })

    return response.data.hotels
  }
}
